import React from "react";

export const Screen = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none">
            <path
                d="M68.3485 64H15.6515C15.2141 64 15 63.6784 15 63.494V20.506C15 20.3216 15.2141 20 15.6515 20H68.3485C68.7859 20 69 20.3216 69 20.506V63.494C69 63.6784 68.7859 64 68.3485 64Z"
                stroke="#BBBBBB" strokeWidth="2" strokeMiterlimit="10"/>
            <path
                d="M16.7051 21C15.7105 21 15 21.6316 15 22.2632V24.8947H68V22.3684C68 21.6316 67.1475 21.1053 66.2949 21.1053H16.7051V21Z"
                fill="#BBBBBB"/>
            <path d="M68 21H15V25H68V21Z" fill="#BBBBBB"/>
            <path
                d="M57.2857 38.3228C56.8571 36.9937 55.8571 36.0633 54.4286 35.6646C52 35 42 35 42 35C42 35 32 35 29.5714 35.6646C28.1429 36.0633 27.1429 36.9937 26.7143 38.3228C26 40.5823 26 45.5 26 45.5C26 45.5 26 50.2848 26.7143 52.6772C27.1429 54.0063 28.1429 54.9367 29.5714 55.3354C32 56 42 56 42 56C42 56 52 56 54.4286 55.3354C55.8571 54.9367 56.8571 54.0063 57.2857 52.6772C58 50.4177 58 45.5 58 45.5C58 45.5 58 40.7152 57.2857 38.3228Z"
                fill="#FE9235"/>
            <path d="M39 50L46 45.4328L39 41V50Z" fill="white"/>
            <circle cx="18" cy="22" r="1" fill="white"/>
            <circle cx="22" cy="22" r="1" fill="white"/>
            <circle cx="26" cy="22" r="1" fill="white"/>
        </svg>
    )
}
